import { SVGProps, ComponentType } from 'react';
import Airport from '@engineering/icons/airport';
import CityStation from '@engineering/icons/city-station';
import TrainStation from '@engineering/icons/train-station';
import styled from '@emotion/styled';

import {
  SearchDestinationType,
  SearchSuggestion,
} from '@silvertours/front-entities';

import StationMarker from '@engineering/icons/station-marker';
import { IconWrapper, Price } from './LocationSuggest.styles';

// Google's Highlight style
const ItemSpan = styled.span`
  font-weight: 600;

  & > mark {
    background-color: inherit;
    color: inherit;
    font-weight: normal;
  }
`;

const icons: {
  [K in SearchDestinationType]?: ComponentType<SVGProps<SVGSVGElement>>;
} = {
  city: CityStation,
  citywithoutrail: CityStation,
  multiairports: Airport,
  multiairport_single: Airport,
  airport: Airport,
  multirail: TrainStation,
  rail_only: TrainStation,
  multirail_single: TrainStation,
  all: StationMarker,
  normal: StationMarker,
  rail: TrainStation,
};

export const SearchResultItem = ({
  suggestion,
}: {
  suggestion: SearchSuggestion;
}) => {
  const Icon = icons[suggestion.type];

  return (
    <>
      <IconWrapper aria-hidden="true">
        {Icon && <Icon width="24" height="24" />}
      </IconWrapper>
      {/* eslint-disable-next-line react/no-danger */}
      <ItemSpan
        role="gridcell"
        dangerouslySetInnerHTML={{
          __html: suggestion.htmlTitle ?? suggestion.title ?? '',
        }}
      />
      {suggestion.minPrice && (
        <Price role="gridcell">{suggestion.minPrice}</Price>
      )}
    </>
  );
};
